import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import StickySquare from 'components/StickySquare'
import { GOODS_TYPES } from 'constants/sales'
import CartSaleWideContainer from 'containers/CartSaleWideContainer'
import { LayoutContext } from 'contexts/Layout'
import { LocalizationContext } from 'contexts/Localization'
import { MenuMainContext } from 'contexts/MenuMain'
import { ResizeContext } from 'contexts/Resize'
import {
  white,
  bodyColor,
  purpleHeart,
  cerulean,
  macaroniAndCheese,
  lilac,
} from 'styles/theme/colors'

import WHowAnalyse from './components/WHowAnalyse'
import WHowFirst from './components/WHowFirst'
import WHowInterpreting from './components/WHowInterpreting'
import WHowOrder from './components/WHowOrder'
import WHowProtection from './components/WHowProtection'
import WHowRegister from './components/WHowRegister'
import WHowResults from './components/WHowResults'
import WHowReturn from './components/WHowReturn'
import WHowSpit from './components/WHowSpit'
import { SectionsWrapperStyled } from './styles'

const STICKY_SQUARE_BG_COLORS = [
  purpleHeart,
  cerulean,
  cerulean,
  white,
  lilac,
  lilac,
  macaroniAndCheese,
]
const STICKY_SQUARE_TEXT_COLORS = [
  white,
  white,
  white,
  bodyColor,
  white,
  white,
  white,
]

const WgsHowItWorks = props => {
  const { texts, pathCdn } = props
  const [stickySquareActive, setStickySquareActive] = React.useState(false)
  const [blocks] = React.useState(() =>
    STICKY_SQUARE_BG_COLORS.map(() => React.createRef()),
  )
  const { menuNode } = React.useContext(MenuMainContext)
  const { locale } = React.useContext(LocalizationContext)
  const { mobile } = React.useContext(ResizeContext)
  const { setFooterBg, setFooterColor, setBodyColor } = React.useContext(
    LayoutContext,
  )
  const { colors } = React.useContext(ThemeContext)

  React.useEffect(() => {
    setFooterBg(colors.purpleHeart)
    setFooterColor(colors.whiteOp5)
    setBodyColor(colors.black)

    return () => {
      setFooterBg(null)
      setFooterColor(null)
      setBodyColor(null)
    }
  }, [setFooterBg, colors, setFooterColor, setBodyColor])

  return (
    <>
      <WHowFirst data={texts.first} secondBlockRef={blocks[0]} />

      <div ref={blocks[0]}>
        <WHowOrder
          index={1}
          data={texts.order_wgs}
          isSquareHidden={stickySquareActive}
          {...{ pathCdn }}
        />
      </div>

      <div ref={blocks[1]}>
        <WHowRegister
          {...{ pathCdn }}
          index={2}
          data={texts.register_kit}
          isSquareHidden={stickySquareActive}
        />
      </div>

      <div ref={blocks[2]}>
        <WHowSpit
          {...{ pathCdn }}
          index={3}
          data={texts.spit}
          isSquareHidden={stickySquareActive}
        />
      </div>

      <div ref={blocks[3]}>
        <WHowReturn
          index={4}
          data={texts.return_kit}
          isSquareHidden={stickySquareActive}
        />
      </div>

      <div ref={blocks[4]}>
        <WHowAnalyse
          index={5}
          data={texts.analyse}
          isSquareHidden={stickySquareActive}
          pathCdn={pathCdn}
        />
      </div>

      <div ref={blocks[5]}>
        <WHowInterpreting
          index={6}
          data={texts.interpreting}
          isSquareHidden={stickySquareActive}
        />
      </div>

      <div ref={blocks[6]}>
        <WHowResults
          index={7}
          data={texts.get_results}
          pathCdn={pathCdn}
          locale={locale}
          isSquareHidden={stickySquareActive}
        />
      </div>

      <div>
        <WHowProtection data={texts.protection} />
      </div>

      <SectionsWrapperStyled isOverflowHidden={true}>
        <CartSaleWideContainer productType={GOODS_TYPES.wgs} />
      </SectionsWrapperStyled>

      {!mobile && (
        <StickySquare
          topOffsetNode={menuNode}
          isActive={stickySquareActive}
          blocks={blocks}
          squareColors={STICKY_SQUARE_BG_COLORS}
          textColors={STICKY_SQUARE_TEXT_COLORS}
          activateStickyHandler={() => setStickySquareActive(true)}
          deactivateStickyHandler={() => setStickySquareActive(false)}
        />
      )}
    </>
  )
}

WgsHowItWorks.propTypes = {
  pathCdn: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
}

export default WgsHowItWorks
